import { msJsClient } from '@/apiClients';
import type { BalanceInfo } from '@wolfejs/ms-ui/Funds/types';

export async function getFundsDetails(): Promise<Partial<BalanceInfo> | undefined | string> {
  try {
    const { data: response } = await msJsClient.myaccount.getFunds();
    const { actual_balance: balance, uuid: id } = response.data[0];
    if (!id) return;

    return { amount: balance };
  } catch (error) {
    console.error(error);
    return;
  }
}

export async function getFundsId(): Promise<undefined | string> {
  try {
    const { data: response } = await msJsClient.myaccount.getFunds();
    const { uuid: id } = response.data[0];

    return id;
  } catch (error) {
    console.error(error);
    return;
  }
}
